// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { FxBreadcrumbs } from 'axp-fx-common';
// eslint-disable-next-line no-unused-vars
import PageHeader from '../Headers/PageHeader';
// eslint-disable-next-line no-unused-vars
import UpdatePasswordForm from './UpdatePasswordParentForm';
// eslint-disable-next-line no-unused-vars
import UpdatePasswordResponse from './UpdatePasswordResponse';
import { combineBaseBreadcrumbWithFinal } from '../../../constants/breadcrumbs';

const UpdatePassword = ({
  selectedFxAccount,
  setStepNo,
  baseBreadcrumb,
  finalBreadcrumb,
  pageHeaderTxt,
  actionButtonLabelTxt,
  performAnotherActionButtonTxt,
  action,
}) => {
  const [updatePasswordStepNo, setUpdatePasswordStepNo] = useState(1);

  const [updatedFxAccount, setUpdatedFxAccount] = useState({});

  return (
    <>
      <FxBreadcrumbs breadcrumbItems={combineBaseBreadcrumbWithFinal(baseBreadcrumb, finalBreadcrumb)} />

      <PageHeader headerText={pageHeaderTxt} />

      {updatePasswordStepNo === 1 && (
        <UpdatePasswordForm
          selectedFxAccount={selectedFxAccount}
          setStepNo={setStepNo}
          setUpdatePasswordStepNo={setUpdatePasswordStepNo}
          setUpdatedFxAccount={setUpdatedFxAccount}
          actionButtonLabelTxt={actionButtonLabelTxt}
          action={action}
        />
      )}
      {updatePasswordStepNo === 2 && (
        <UpdatePasswordResponse
          updatedFxAccount={updatedFxAccount}
          performAnotherActionButtonTxt={performAnotherActionButtonTxt}
          action={action}
        />
      )}
    </>
  );
};

UpdatePassword.propTypes = {
  selectedFxAccount: PropTypes.shape({
  }).isRequired,
  setStepNo: PropTypes.func.isRequired,
  baseBreadcrumb: PropTypes.arrayOf().isRequired,
  finalBreadcrumb: PropTypes.shape({}).isRequired,
  pageHeaderTxt: PropTypes.string.isRequired,
  actionButtonLabelTxt: PropTypes.string.isRequired,
  performAnotherActionButtonTxt: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
};

export default UpdatePassword;
